module.exports = __webpack_public_path__ + "img/default-product.29e298d9.jpeg";